'use client';

import { useMemo } from 'react';

import { usePathname, useSearchParams } from 'next/navigation';

import { stablePathQueryKey } from '@/modules/common/lib/utils';

export function useUiKey() {
  const pathname = usePathname();
  const params = useSearchParams();

  return useMemo(() => stablePathQueryKey(pathname, params), [pathname, params]);
}
